import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import DetailModalSC from './detail-modal.styled';
import { HeadingTwo, BodyText, SmallText } from '../../typography';
import InlineLoading from '../../ui/inline-loading';
import Moment from 'react-moment';
import { ReactComponent as FileIcon } from '../../../assets/img/svg/pdf.svg';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { LS_ACCESS_TOKEN } from '../../../constants';

const _DetailModal = ({ selectedDetail, type, emails, sms, letters }) => {
  const [messageData, setMessageData] = useState(null);

  useEffect(() => {
    let singleItemData = '';
    if (selectedDetail !== null && type === 'emails') {
      singleItemData = emails.filter((message) => message.id === selectedDetail);
      setMessageData(...singleItemData);
    } else if (selectedDetail !== null && type === 'sms') {
      singleItemData = sms.filter((sms) => sms.id === selectedDetail);
      setMessageData(...singleItemData);
    } else if (selectedDetail !== null && type === 'letters') {
      singleItemData = letters.filter((letter) => letter.id === selectedDetail);
      setMessageData(...singleItemData);
    } else {
      setMessageData(null);
    }
  }, [selectedDetail, type, emails, sms, letters]);

  const onDocumentClick = (docLink) => {
    window.open(
      `${process.env.REACT_APP_WISHMAKER_API_URI}${
        process.env.REACT_APP_DOC_SLUG
      }/${docLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
    );
  };

  if (selectedDetail === null || messageData === null) {
    return (
      <DetailModalSC>
        <div className="modal-loading-wrap">
          <InlineLoading />
        </div>
      </DetailModalSC>
    );
  }
  return (
    <DetailModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">{messageData.subject}</HeadingTwo>

        <div className="top-text-wrap--infos">
          <div>
            <BodyText className="bold">
              <FormattedMessage
                id="mailbox_modal_sent"
                defaultMessage={dlt['mailbox_modal_sent']}
              />
            </BodyText>
            <BodyText className="black-transparent">
              <Moment format="DD. MMMM YYYY">{messageData.created_at}</Moment>
            </BodyText>
          </div>
          {type === 'letters' ? (
            <div>
              <BodyText className="bold">
                <FormattedMessage
                  id="mailbox_letters_address"
                  defaultMessage={dlt['mailbox_letters_address']}
                />{' '}
              </BodyText>
              <BodyText className="black-transparent">{messageData.recipient}</BodyText>
            </div>
          ) : (
            <div>
              <BodyText className="bold">
                <FormattedMessage
                  id="mailbox_modal_from"
                  defaultMessage={dlt['mailbox_modal_from']}
                />
              </BodyText>
              <BodyText className="black-transparent">{messageData.sender}</BodyText>
            </div>
          )}
        </div>
        <BodyText>
          <span dangerouslySetInnerHTML={{ __html: messageData.message }} />
        </BodyText>
      </div>
      {messageData.documents && messageData.documents.length > 0 ? (
        <div className="documents-wrap">
          <BodyText className="bold">
            <FormattedMessage
              id="mailbox_modal_documents"
              defaultMessage={dlt['mailbox_modal_documents']}
            />
          </BodyText>
          <div className="documents-wrap--items-wrap">
            {messageData.documents.map((doc) => {
              return (
                <button className="document" onClick={() => onDocumentClick(doc.url)} key={doc.url}>
                  <FileIcon />
                  <SmallText>{doc.name}</SmallText>
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </DetailModalSC>
  );
};

const mapStateToProps = (state) => {
  return {
    emails: state.mailbox.emails,
    sms: state.mailbox.sms,
    letters: state.mailbox.letters,
  };
};

const DetailModal = connect(mapStateToProps)(_DetailModal);

export default DetailModal;
